import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import React from "react"

const options = [
    { id: "头条文章", name: "头条文章"},
    { id: "视频", name: "视频"},
    { id: "图文", name: "图文"},
    { id: "转发", name: "转发"},
]

const ITEM_HEIGHT = 48
interface ComponentProps {
    initialValue?: string,
    onChange: (value: string) => void,
}
const ContentTypeSelect = (props: ComponentProps) => {
    const { onChange, initialValue = "" } = props
    const [ value, setValue ] = React.useState(initialValue)
    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setValue(event.target.value as string)
        onChange(event.target.value as string)
    }
    return (
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            onChange={handleChange}
            MenuProps={{
                style: {
                    maxHeight: ITEM_HEIGHT * 10.5,
                    width: 200,
                },
            }}
        >
            {options.map((c: any) => (
                <MenuItem value={c.id} key={c.id}>{c.name}</MenuItem>
            ))}
        </Select>
    )
}

export default ContentTypeSelect
